module.exports = __webpack_public_path__ + "assets/img/ef393e07c43517662bc880e3cff80d20.png";